import { JoonColorExpanded } from "@joonapp/web-shared"
import SendbirdProvider from "@sendbird/uikit-react/SendbirdProvider"

import { useSBCredentialsQuery } from "../../networking/users/queries"
import useCareTeam from "../../pages/care/useCareTeam"
import "@sendbird/uikit-react/dist/index.css"

const SBProvider = (props: { children: React.ReactNode }) => {
  const { hasCoach } = useCareTeam()
  const { data: SBCredentials } = useSBCredentialsQuery(hasCoach)

  const myColorSet = {
    "--sendbird-light-primary-500": JoonColorExpanded.purple600,
    "--sendbird-light-primary-400": JoonColorExpanded.purple600,
    "--sendbird-light-primary-300": JoonColorExpanded.purple600,
    "--sendbird-light-primary-200": JoonColorExpanded.purple200,
    "--sendbird-light-primary-100": JoonColorExpanded.purple100,
  }

  return (
    <SendbirdProvider
      colorSet={myColorSet}
      appId={import.meta.env.VITE_SENDBIRD_APP_ID}
      userId={SBCredentials?.sendbird_user_id || ""}
      accessToken={SBCredentials?.sendbird_access_token}
    >
      {props.children}
    </SendbirdProvider>
  )
}

export default SBProvider
